import { render, staticRenderFns } from "./getApp.vue?vue&type=template&id=6a574cf6"
import script from "./getApp.vue?vue&type=script&lang=js"
export * from "./getApp.vue?vue&type=script&lang=js"
import style0 from "./getApp.vue?vue&type=style&index=0&id=6a574cf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports